import { ProgramEventType, ProgramFeatures } from '@citruscamps/citrus-client'

export const isEventTypeValid = (type: ProgramEventType, flags: ProgramFeatures): boolean =>
  type !== 'session' || flags.sessions_enabled
